import { format } from "date-fns";
import { Currency, formatPrice } from "../utils/utils";

export const formatList = (list, tdsPercent) => {
  return list.map((listItem) => {
    const { sales } = listItem;
    const { data } = sales;
    const getTotalOrderLength = () => {
      let length = 0;
      data.customerOrder.forEach((order) => {
        length += order.customerDetails.length;
      });
      return length;
    };
    return {
      Customer: data.bookingCustomerDetails.name,
      "Offering Name": data.featureDetails.name,
      "Booked For": getTotalOrderLength(),
      "Order Id": data.id,
      "Booking Date": format(new Date(sales.saleDate), "dd MMM yyyy, HH:mm"),
      "Cart Value": formatPrice(
        data.paymentBreakdown.cartValue,
        data.paymentBreakdown.currency,
        "code"
      ),
      Discount: formatPrice(
        data.paymentBreakdown.discount,
        data.paymentBreakdown.currency,
        "code"
      ),
      "Amount Paid": formatPrice(
        data.paymentBreakdown.totalAmount,
        data.paymentBreakdown.currency,
        "code"
      ),
      GST: formatPrice(
        data.paymentBreakdown.gst,
        data.paymentBreakdown.currency,
        "code"
      ),
      "Growezy Commission": formatPrice(
        data.paymentBreakdown.platformFee,
        data.paymentBreakdown.currency,
        "code"
      ),
      "PG Charges": formatPrice(
        data.paymentBreakdown.convenience,
        data.paymentBreakdown.currency,
        "code"
      ),
      "Commission Paid By": data.paymentBreakdown.isCommissionIncluded
        ? "You"
        : "Customer",
      "PG Charges Paid By": data.paymentBreakdown.isConvenienceIncluded
        ? "You"
        : "Customer",
      "Total Receivable": formatPrice(data.payoutAmount, Currency.INR, "code"),
      TDS: `${tdsPercent * 100} %`,
      "Total Receivable After TDS": formatPrice(
        data.payoutAmount * (1 - tdsPercent),
        Currency.INR,
        "code"
      ),
    };
  });
};
